// removed by extract-text-webpack-plugin
module.exports = {"suffix":"_2r_34CQjVoOcBr-FBzOkY6","prefix":"_1nVNBrGEFhJU_Zi_RC9C82"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/Backoffice/Button/Button.scss
// module id = ./node_modules/wix-style-react/dist/es/src/Backoffice/Button/Button.scss
// module chunks = 0